import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../organisms/Sidebar';
import { ThemeToggle } from '../atoms/ThemeToggle';

export const MainLayout: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-cream-100 via-warm-100 to-cream-200 dark:bg-gradient-to-br dark:from-dark-100 dark:via-dark-200 dark:to-dark-100">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <div className="flex justify-end p-6">
          <ThemeToggle />
        </div>
        <main className="flex-1 px-8 pb-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
